module.exports = __webpack_public_path__ + "application/templates/default/inner/publications/inner/publications-details/publications-details.template.html";